export const MODAL_TYPE = {
  REMOVE_ALL_FAVORITE_DEVICES: 'REMOVE_ALL_FAVORITE_DEVICES',
  REMOVE_ALL_COMPARE_DEVICES: 'REMOVE_ALL_COMPARE_DEVICES',
  DETAILS_DEVICE: 'DETAILS_DEVICE',
};
